var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        id: "handleClaimDialog",
        title: _vm.title,
        visible: _vm.isShow,
        width: _vm.data && _vm.data.businessNo ? "1300px" : "700px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
      },
      on: {
        close: _vm.closeDialog,
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialogInner_class",
          attrs: {
            width: "500px",
            title: "设置联系电话",
            visible: _vm.innerVisible,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.innerVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.setPhoneLoading,
                  expression: "setPhoneLoading",
                },
              ],
              ref: "phoneForm",
              attrs: { model: _vm.phoneForm, "label-width": "100px" },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "phoneForm-style",
                  attrs: {
                    label: "联系电话",
                    prop: "phone",
                    rules: _vm.phoneRules,
                  },
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off" },
                    model: {
                      value: _vm.phoneForm.phone,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.phoneForm,
                          "phone",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "phoneForm.phone",
                    },
                  }),
                ],
                1
              ),
              _c("span", { staticClass: "complainTitle" }, [
                _vm._v(
                  "提示：客户管家App/PC发起工单、处理问题件、发起理赔将优先带入此处设置的联系电话。"
                ),
              ]),
              _c(
                "div",
                { staticClass: "btnn" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.resetPhoneForm("phoneForm")
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.submitPhoneForm("phoneForm")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: { id: "handleClaim" },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.phoneLoading,
                  expression: "phoneLoading",
                },
              ],
              staticStyle: { width: "620px" },
            },
            [
              _c("div", { staticClass: "info-title mb20" }, [
                _vm._v("理赔信息"),
              ]),
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    inline: true,
                    "label-width": "100px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "运单号", prop: "waybillNo" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请输入运单号",
                          disabled: _vm.waybillNoFlag,
                        },
                        model: {
                          value: _vm.ruleForm.waybillNo,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "waybillNo",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.waybillNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "理赔类型",
                        prop: "indemnityType",
                        "label-width": "110px",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            disabled: _vm.readOnlyFlag,
                          },
                          model: {
                            value: _vm.ruleForm.indemnityType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "indemnityType", $$v)
                            },
                            expression: "ruleForm.indemnityType",
                          },
                        },
                        _vm._l(_vm.indemnityType, function (val) {
                          return _c("el-option", {
                            key: val.value,
                            attrs: { label: val.name, value: val.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "物品类型", prop: "indemnityGoodsType" },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择",
                            disabled: _vm.readOnlyFlag,
                          },
                          model: {
                            value: _vm.ruleForm.indemnityGoodsType,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "indemnityGoodsType", $$v)
                            },
                            expression: "ruleForm.indemnityGoodsType",
                          },
                        },
                        _vm._l(_vm.indemnityGoodsType, function (val) {
                          return _c("el-option", {
                            key: val.value,
                            attrs: { label: val.name, value: val.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "moneyStyle",
                      attrs: {
                        label: "物品价值",
                        prop: "indemnityGoodsWorth",
                        "label-width": "110px",
                      },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          precision: 2,
                          step: 0.01,
                          disabled: _vm.readOnlyFlag,
                          placeholder: "请输入",
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.ruleForm.indemnityGoodsWorth,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "indemnityGoodsWorth", $$v)
                          },
                          expression: "ruleForm.indemnityGoodsWorth",
                        },
                      }),
                      _c("span", { staticStyle: { width: "20px" } }, [
                        _vm._v("元"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "moneyStyle",
                      attrs: { label: "理赔金额", prop: "indemnityAmount" },
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "180px" },
                        attrs: {
                          precision: 2,
                          step: 0.01,
                          disabled: _vm.readOnlyFlag,
                          placeholder: "请输入",
                          "controls-position": "right",
                        },
                        model: {
                          value: _vm.ruleForm.indemnityAmount,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "indemnityAmount", $$v)
                          },
                          expression: "ruleForm.indemnityAmount",
                        },
                      }),
                      _c("span", { staticStyle: { width: "20px" } }, [
                        _vm._v("元"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "sponsorTel-style",
                      attrs: {
                        label: "发起人电话",
                        prop: "sponsorTel",
                        "label-width": "110px",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          placeholder: "请输入",
                          disabled: _vm.readOnlyFlag,
                        },
                        model: {
                          value: _vm.ruleForm.sponsorTel,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "sponsorTel",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.sponsorTel",
                        },
                      }),
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "margin-left": "5px",
                            "padding-left": "0",
                            "padding-right": "0",
                            width: "50px",
                          },
                          attrs: {
                            disabled: _vm.waybillNoFlag || _vm.readOnlyFlag,
                            type: "primary",
                            plain: "",
                          },
                          on: { click: _vm.settingPhone },
                        },
                        [_vm._v("设置")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "收件人姓名", prop: "receiveName" } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readOnlyFlag
                            ? ""
                            : "请输入收件人姓名",
                          maxlength: "12",
                          disabled: _vm.readOnlyFlag,
                        },
                        model: {
                          value: _vm.ruleForm.receiveName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "receiveName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.receiveName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "收件人电话",
                        prop: "receiveTel",
                        "label-width": "110px",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.readOnlyFlag
                            ? ""
                            : "请输入收件人电话",
                          disabled: _vm.readOnlyFlag,
                        },
                        model: {
                          value: _vm.ruleForm.receiveTel,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "receiveTel",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.receiveTel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "textArea-style",
                      attrs: { label: "收件地址", prop: "receiveAddress" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "100",
                          rows: "2",
                          disabled: _vm.readOnlyFlag,
                          "show-word-limit": "",
                          placeholder: _vm.readOnlyFlag ? "" : "请输入收件地址",
                        },
                        model: {
                          value: _vm.ruleForm.receiveAddress,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "receiveAddress",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.receiveAddress",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "textArea-style",
                      attrs: { label: "理赔描述", prop: "indemnityContent" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          maxlength: "1000",
                          rows: "3",
                          disabled: _vm.readOnlyFlag,
                          "show-word-limit": "",
                          placeholder: "请输入理赔原因",
                        },
                        model: {
                          value: _vm.ruleForm.indemnityContent,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.ruleForm,
                              "indemnityContent",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "ruleForm.indemnityContent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "img-form",
                      attrs: { label: "图片", prop: "img" },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "uploadImg",
                          class: { hide: _vm.showUpload },
                          attrs: {
                            disabled: _vm.readOnlyFlag,
                            action:
                              "/steward/web/indemnityHInforController/uploadIndemnityImg",
                            "list-type": "picture-card",
                            limit: 6,
                            accept: ".jpg,.jpeg,.png,.gif",
                            "on-exceed": _vm.handleExceed,
                            headers: _vm.headers,
                            "file-list": _vm.fileList,
                            "before-upload": _vm.beforeAvatarUpload,
                            "on-success": _vm.uploadSuccess,
                            "on-preview": _vm.handlePictureCardPreview,
                            "on-remove": _vm.handleRemove,
                          },
                        },
                        [
                          _c("i", { staticClass: "el-icon-plus" }, [
                            _vm._v("上传照片"),
                          ]),
                        ]
                      ),
                      _vm.data.type &&
                      _vm.data.type != "start" &&
                      _vm.showUpload &&
                      (!_vm.fileList ||
                        (_vm.fileList && _vm.fileList.length < 1))
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                position: "absolute",
                                top: "0px",
                                width: "100Px",
                              },
                            },
                            [_vm._v("暂无图片")]
                          )
                        : _vm._e(),
                      !_vm.readOnlyFlag && !_vm.showUpload
                        ? _c("div", {
                            attrs: { id: "tar_box", contenteditable: "" },
                            on: { input: _vm.focusTarBox },
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "el-upload__tip" }, [
                        _vm._v(
                          "支持jpg、jpeg、gif、png格式的图片，最多上传6张，支持复制粘贴上传"
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm.data &&
                  _vm.data.businessNo &&
                  (_vm.data.indemnityStatus == 1 ||
                    _vm.data.indemnityStatus == 3) &&
                  _vm.data.type &&
                  _vm.data.type == "deal"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "textArea-style remark",
                          attrs: { label: "备注内容", prop: "remark" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              maxlength: "1000",
                              rows: "3",
                              "show-word-limit": "",
                              placeholder: "请输入备注",
                            },
                            on: { blur: _vm.removeErrorMsg },
                            model: {
                              value: _vm.remark,
                              callback: function ($$v) {
                                _vm.remark = $$v
                              },
                              expression: "remark",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.data &&
                  !_vm.data.businessNo &&
                  _vm.data.type &&
                  _vm.data.type == "start"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "form-btn",
                          attrs: { "label-width": "0" },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("取消")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: _vm.saveDisabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.data &&
                  _vm.data.businessNo &&
                  (_vm.data.indemnityStatus == 1 ||
                    _vm.data.indemnityStatus == 3) &&
                  _vm.data.type &&
                  _vm.data.type == "deal"
                    ? _c(
                        "el-form-item",
                        {
                          staticClass: "form-btn claimOrderSubmit",
                          attrs: { "label-width": "0" },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                disabled: _vm.updateDisabled,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.claimOrderSubmit("ruleForm")
                                },
                              },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm.data && _vm.data.businessNo
            ? _c(
                "div",
                { staticClass: "timeline" },
                [
                  _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.handleClick },
                      model: {
                        value: _vm.activeLog,
                        callback: function ($$v) {
                          _vm.activeLog = $$v
                        },
                        expression: "activeLog",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: { label: "理赔轨迹", name: "first" },
                      }),
                      _c("el-tab-pane", {
                        attrs: { label: "修改记录", name: "second" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.logLoading,
                          expression: "logLoading",
                        },
                      ],
                    },
                    [
                      _vm.orderData.length > 0
                        ? _c(
                            "ul",
                            _vm._l(_vm.orderData, function (item, i) {
                              return _c(
                                "li",
                                { key: i, staticClass: "timeline-item-first" },
                                [
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "timeline-item-time" },
                                      [
                                        _c("h3", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getDateTime(
                                                item["modifyTime"]
                                              )
                                            )
                                          ),
                                        ]),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getDateTime(
                                                item["modifyTime"],
                                                1
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "timeline-item-color" },
                                      [_c("i", { staticClass: "circle-icon" })]
                                    ),
                                    _c("div", {
                                      staticClass: "timeline-item-tail",
                                    }),
                                    _c(
                                      "div",
                                      { staticClass: "timeline-item-content" },
                                      [
                                        _vm.activeLog === "first"
                                          ? _c("p", [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "600",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getProcessInfo(
                                                        item["title"]
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c("span", [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      _vm.getProcessInfo(
                                                        item["subTitle"]
                                                      )
                                                    ) +
                                                    ")"
                                                ),
                                              ]),
                                            ])
                                          : _c("p", [
                                              _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    "font-weight": "600",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getProcessInfo(
                                                        item["subTitle"]
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]),
                                        item.content
                                          ? _c("p", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getProcessInfotoList(
                                                    item["content"]
                                                  )
                                                ),
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                ],
                                2
                              )
                            }),
                            0
                          )
                        : _c(
                            "div",
                            {
                              staticStyle: {
                                width: "467px",
                                "text-align": "center",
                                "margin-top": "20px",
                              },
                            },
                            [_vm._v("暂无数据")]
                          ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }